export var TAB = /\t/;
export var WHITESPACE = /\s/;
export var NEW_LINE = /(\r\n|\r|\n)/;
export var COLON = /:/;
export var DOUBLE_COLON = /::/;
export var NUMBERS_AND_DOT = /[0-9\.]/;
export var A_TO_Z_AND_DOT = /[a-z0-9\.$]/i;
export var NEGATION = /^(isnt|arent|aint|negate|!)$/i;
export var DEFAULT = /^(default|none)$/i;
export var ARGUMENT = /^(each|than|with|without|for|between|by|at|to|until|and|or|below|under|on|since|ago|past|into|from|about|through|across|after)$/i;
export var BREAK_LINE = '\r\n';
export var ARROW = /->/;
export var UNION = /U/;
export var VARIADIC = /\.\.\.|ary/;
export var FLIP = /flip$/;
export var DEFER = /defer$/;
export var WRAP = /wrap$/;
export var AGREGGATOR = /aggregate$/;